import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';

export interface Benefit {
  name: string;
  featured: boolean;
  icon: string;
  inactive?: boolean;
}

/**
 * Relationship classes
 */
export class PlanBenefitAttributes {
  benefits: Benefit[] = null;
  createdAt: string = null;
  id: string = null;
  mostPopular: boolean = null;
  name: string = null;
  reactivateButtonText: string = null;
  subheading: string = null;
  tier: number = null;
  trialButtonText: string = null;
  updatedAt: string = null;
}

export class PlanBenefitBelongsTo {}
export class PlanBenefitHasOne {}
export class PlanBenefitHasMany {}

/**
 * Utility interfaces
 */
export interface PlanBenefitMethods {}

export interface PlanBenefitInterface extends PlanBenefitAttributes, PlanBenefitType {}

type PlanBenefitType = GConstructor<PlanBenefitInterface>;

export interface PlanBenefitResource
  extends Base<PlanBenefitAttributes>,
    PlanBenefitInterface,
    PlanBenefitMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<PlanBenefitAttributes>({
    queryName: 'employers/plan_benefits',
    className: 'PlanBenefit',
    AttributesClass: PlanBenefitAttributes,
  });

export const PlanBenefitResourceClass = <TBase extends PlanBenefitType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements PlanBenefitMethods {};

export class PlanBenefitResource extends ClassExtender<PlanBenefitInterface>(
  BaseClass,
  PlanBenefitResourceClass,
) {}

/**
 * Resource instance
 */
export const PlanBenefit = APILibrary.createResource<PlanBenefitResource>(PlanBenefitResource);
